@if (groupedLinkList()?.items; as items) {
  <ul class="footer-nav-list">
    <li class="footer-nav-list__header">{{ groupedLinkList().category | toI18nKey | translate }}</li>
    @if (groupedLinkList().category !== 'STORE_ENTRYS') {
      @for (item of items; track item.route) {
        <li class="footer-nav-list__item--link">
          <a [routerLink]="item.route" [title]="item.a11y | translate">{{ item.i18n | translate }}</a>
        </li>
      }
    }
    @if (groupedLinkList().category === 'STORE_ENTRYS') {
      <li class="footer-nav-list__item">
        @for (item of items; track item.route) {
          <a [href]="item.route | translate">
            <img class="store-svg" [alt]="item.i18n | translate" [src]="item.icon" />
          </a>
        }
      </li>
    }
  </ul>
}
